require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-portland-computer-science-web-development-course-starts-nov-3rd.json") })
        }
      }, "path---blog-portland-computer-science-web-development-course-starts-nov-3rd");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-portland-computer-science-web-development-course-starts-nov-3rd!./.cache/json/blog-portland-computer-science-web-development-course-starts-nov-3rd.json
// module id = 1017
// module chunks = 231608221292675